// extracted by mini-css-extract-plugin
module.exports = {"pagination":"PaginationComponentV2_pagination__3QLhr","disabled-text":"PaginationComponentV2_disabled-text__3at0d","text":"PaginationComponentV2_text__1LHoF"};